module.exports = __webpack_public_path__ + "static/media/_DSC1580.570dbf57.jpg";